const quantities = ['qty1', 'qty2', 'qty3', 'qty4'];

export const isParameterNameQtyValid = (name) => quantities.includes(name);

export const isProductTypeParameterNameQtyValid = (name, product_type) => quantities.map((q) => `${product_type}_${q}`).includes(name);
